import { atom } from "recoil";
import { CHEST_PRIZE_TYPE_OPTIONS } from "../helpers/chestPrizeTypes";

export const chestPrizeAddModalStore = atom({
	key: "chestPrizeAddModalStore",
	default: {
		show: false,
		loaded: true,
		name: "",
		type: null,
		typeOptions: CHEST_PRIZE_TYPE_OPTIONS,
		chestRewards: [],
	},
});
